module.exports = __webpack_public_path__ + "static/img/lexus.366af99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lexus.png
// module id = 3xaj
// module chunks = 1